<template>
  <div class="mobile-app bg-white">
    <div class="container">
      <div
        class="flex flex-col md:flex-row items-center gap-10 border border-gray-200 border-solid rounded-xl"
      >
        <div class="md:w-1/2">
          <div class="mobile-app-content space-y-6 p-10">
            <div class="space-y-2">
              <h2 class="text-[34px] font-semibold text-[#222222]">
                Qaji Guide
              </h2>
              <p class="text-[#5E5F5F] text-lg">
                Қажылық және ұмра өтеушілерге арналған тегін цифрлық көмекші
                құрал
              </p>
            </div>

            <div class="flex flex-wrap gap-4">
              <a
                href="https://play.google.com/store/apps/details?id=kz.qmdb.qajyguide"
                class="block w-[150px] h-[40px]"
                target="_blank"
              >
                <img src="@/assets/images/google-play.png" alt="Google Play" />
              </a>
              <a
                href="https://apps.apple.com/kz/app/qajy-guide/id6504259376"
                class="block w-[150px] h-[40px]"
                target="_blank"
              >
                <img src="@/assets/images/app-store.png" alt="App Store" />
              </a>
            </div>
          </div>
        </div>

        <div class="md:w-1/2 relative flex items-center justify-end">
          <img
            src="@/assets/images/app.png"
            alt="Qaji Guide mobile app"
            class="w-full max-w-md"
          />
        </div>
      </div>
    </div>
  </div>
</template>
